exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-tv-kalender-tsx": () => import("./../../../src/pages/tv-kalender.tsx" /* webpackChunkName: "component---src-pages-tv-kalender-tsx" */),
  "component---src-templates-news-index-tsx": () => import("./../../../src/templates/News/index.tsx" /* webpackChunkName: "component---src-templates-news-index-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

